import { Component, OnInit, Input, Optional, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { FileOptions } from '../../Shared/Models/FileOptions';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { FileUploader, FileDropDirective, FileLikeObject, FileItem } from 'ng2-file-upload';
import { FileDTO } from '../../Shared/Models/FileDTO';


@Component({
  selector: 'BBSF-MultipleFileUplaod',
  templateUrl: './MultipleFileUplaod.component.html',
  styleUrls: ['./MultipleFileUplaod.component.scss']
})
export class MultipleFileUploadComponent implements OnInit {

  static controlContainerstatic = null;

  @ViewChild('fileInput', {static:true,read:null}) fileInput: ElementRef;

  isSubmitted: boolean;
  @Input() group: FormGroup;
  @Input() options: FileOptions;
  @Output() OnChange = new EventEmitter();

  fileUploadFormControl: AbstractControl;
  ValidationMessage = ""
  uploader: FileUploader;
  hasAnotherDropZoneOver: boolean;
  AcceptedType: string = "";
  AcceptedTypeArray: string[] = [];
  ToolTipTypeArray: string[] = [];
  FileLikeObject: FileLikeObject;
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];



  constructor(@Optional() private controlContainer: ControlContainer, public MultipleFileUplaodControlHost: FormGroupDirective, private controlUtility: ControlUtility) {
    MultipleFileUploadComponent.controlContainerstatic = this.controlContainer;
    this.uploader = new FileUploader({
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
    });
    this.hasAnotherDropZoneOver = false

  }


  ngOnInit() {

    if (this.options.Value != null) {

      for (let index = 0; index < this.options.Value.length; index++) {
        const element = this.options.Value[index];
        this.FileLikeObject = new FileLikeObject({
          name: element.FileName,
          size: element.FileSizeInMB * 1000 * 1000,
          type: element.FileType
        })

        this.uploader.addToQueue([this.FileLikeObject as any])
      }

    }

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);


    if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0) {
      for (let index = 0; index < this.options.FileUploadAcceptsTypes.length; index++) {
        const Type = this.options.FileUploadAcceptsTypes[index];
        this.AcceptedType = this.AcceptedType + Type + ","
      }
      this.AcceptedTypeArray = this.AcceptedType.split(",")
      for (let index = 0; index < this.AcceptedTypeArray.length; index++) {
        const element = this.AcceptedTypeArray[index];
        const TypeToolTipe = element.split('/')[1];
        this.ToolTipTypeArray.push(TypeToolTipe);
      }
      this.ValidationMessage = this.ValidationMessage + `Allowed extenstions (${this.ToolTipTypeArray}) `

    }
    if (this.options.FileMaxSizeInMB > 0) {
      this.ValidationMessage = this.ValidationMessage + `<br /> Max File Size ${this.options.FileMaxSizeInMB} MB`
    }

    if (this.options.MinNoOfFiles > 0) {
      this.ValidationMessage = this.ValidationMessage + `<br /> Min File Number is  ${this.options.MinNoOfFiles}`
    }


    if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0) {
    }
    this.group.addControl(this.options.Name, new FormControl(''));
    this.fileUploadFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }


    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }

    this.fileUploadFormControl.setValidators(this.validationRules);
    this.fileUploadFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.fileUploadFormControl.disable();
    }

    this.MultipleFileUplaodControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })
  }

  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  fileOverAnother(event: any): void {
    this.hasAnotherDropZoneOver = event;
  }
  onFileChange() {
    let FilesArray = [];

    if (this.options.IsMultipleFile && this.options.MinNoOfFiles != null && this.options.MinNoOfFiles > 0 && this.options.MinNoOfFiles > this.uploader.queue.length) {
      const formControl = this.fileUploadFormControl;
      formControl.setErrors({ MinFileCountValidationKey: this.options.MinNoOfFiles });
      formControl.markAsTouched();
      this.uploader.queue = []
      return;
    }

    if (this.options.IsMultipleFile && this.options.MaxNoOfFiles != null && this.options.MaxNoOfFiles > 0 && this.options.MaxNoOfFiles < this.uploader.queue.length) {
      const formControl = this.fileUploadFormControl;
      formControl.setErrors({ MaxFileCountValidationKey: this.options.MaxNoOfFiles });
      formControl.markAsTouched();
      this.uploader.queue = []
      return;
    }

    if (this.options.IsMultipleFile && (this.options.MaxSizeForAllFilesInMB != null && this.options.MaxSizeForAllFilesInMB > 0)) {
      let AllSizeFile: number = 0;
      for (let index = 0; index < this.uploader.queue.length; index++) {

        const element = this.uploader.queue[index];
        const file = element.file;
        AllSizeFile = AllSizeFile + file.size
      }
      const MaxSizeForAllFiles = this.options.MaxSizeForAllFilesInMB * 1000 * 1000;
      if (AllSizeFile > MaxSizeForAllFiles) {
        const formControl = this.fileUploadFormControl;
        formControl.setErrors({ MaxSizeForAllFilesInMB: this.options.MaxSizeForAllFilesInMB + 'M' });
        formControl.markAsTouched();
        this.uploader.queue = []
        return;
      }

    }
    for (let index = 0; index < this.uploader.queue.length; index++) {
      const element = this.uploader.queue[index];
      const file = element.file;
      const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
      if (file) {
        const fileType = file.type;
        if (file.size > maxFileSize) {
          const formControl = this.fileUploadFormControl;
          formControl.setErrors({ FileMaxSizeInMB: this.options.FileMaxSizeInMB + 'M' });
          formControl.markAsTouched();
          this.uploader.queue = []
          return;
        }
        if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0 && !(this.AcceptedTypeArray.includes(fileType.toUpperCase()) || this.AcceptedTypeArray.includes(fileType.toLowerCase()))) {
          const formControl = this.fileUploadFormControl;
          formControl.setErrors({ ToolTipTypeError: this.ToolTipTypeArray });
          formControl.markAsTouched();
          this.uploader.queue = []
          return;
        }
        let reader = new FileReader();
        let FileObject = file.rawFile as any;
        reader.readAsDataURL(FileObject);
        reader.onload = () => {
          let FileObject: FileDTO = new FileDTO();
          FileObject.FileName = file.name;
          FileObject.FileType = file.type;
          FileObject.FileBase64 = reader.result.toString().split(',')[1];
          FileObject.FileSizeInMB = ((file.size / 1000) / 1000);
          FilesArray.push(FileObject);
        };

      }

    }
    this.group.get(this.options.Name).setValue(FilesArray)
    this.OnChange.emit(this.group.get(this.options.Name).value)
  }

  removeFromControlValue(item) {
    let ItemList = this.group.get(this.options.Name).value
    ItemList = ItemList.filter(Object => Object.fileName != item._file.name);
    if ((ItemList == null || ItemList == []) && this.options.IsRequired) {
      this.fileUploadFormControl.markAsTouched();
      this.fileUploadFormControl.invalid;
    }
    this.group.get(this.options.Name).setValue(ItemList)

  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.fileUploadFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.fileUploadFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.fileUploadFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.fileUploadFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.fileUploadFormControl)
  }
}


